import { apiRest } from '../api/constants';
const key = `shop:google-session:${apiRest}`;
// This is only a restoration hint. Authentication always requires the server cookie.
export const hasGoogleSession = () => { try { return sessionStorage.getItem(key) === '1'; } catch { return false; } };
export const rememberGoogleSession = () => { try { sessionStorage.setItem(key, '1'); } catch { /* Cookies still govern the current login. */ } };
export const clearGoogleSession = () => { try { sessionStorage.removeItem(key); } catch { /* No persistent hint. */ } };
